<template>
  <page :footerShow="false">
    <template #right>
      <van-count-down
        ref="countDown"
        :time="time"
        format="sss"
        @finish="countdownfinish"
      />
    </template>
    <van-row class="courier-login">
      <van-col span="24" class="courier-login-left">
        <div class="qrcode wechat">
          <qr-code :text="partnerWechatUrl" :size="240"></qr-code>
        </div>
        <div class="text">
          <van-icon name="chat-o" color="#07c160" />
          微信投递
        </div>
      </van-col>
      <!-- <van-col span="12" class="courier-login-right">
        <div class="qrcode">
          <qr-code :text="loginUrl" :size="240" />
          <div class="login-mask" v-if="loginStatu.status !== 'create'">
            <div v-if="loginStatu.status === 'confirmed'">
              <van-icon name="checked" color="#07c160" size="40" />
              <h2>登录成功</h2>
            </div>
            <div v-if="loginStatu.status === 'scaned'">
              <van-image
                width="40"
                height="40"
                :src="loginStatu.user.avatar"
                round
              />
              <h2>{{ loginStatu.user.nickname }}</h2>
            </div>
          </div>
        </div>
        <div class="text">
          <van-icon name="scan" color="#07c160" />
          微信扫描登录
        </div>
      </van-col> -->
    </van-row>
  </page>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { partnerLoginUrl, loginStatus } from "../../apis/index";

export default {
  data() {
    return {
      uuid: uuidv4(),
      loginUrl: "",
      time: 60 * 1000,
      loginStatu: {},
      timer: null
    };
  },
  created() {
    // this.getPartnerLoginUrl();
    // this.$once("hook:beforeDestroy", () => clearInterval(this.timer));
  },
  computed: {
    partnerWechatUrl() {
      return this.$store.state.stationInfo.partnerWechatUrl;
    }
  },
  methods: {
    async getPartnerLoginUrl() {
      const uuid = uuidv4();
      this.uuid = uuid;
      const data = await partnerLoginUrl(uuid);
      this.loginUrl = data.url;
      this.startRefreshStatus();
    },
    countdownfinish() {
      this.$router.replace("/");
    },
    async getLoginStatus() {
      const data = await loginStatus(this.uuid);
      this.loginStatu = data;
      if (data.status === "confirmed") {
        this.loginSucces();
      }
    },
    startRefreshStatus() {
      this.timer = setInterval(this.getLoginStatus, 1000);
    },
    loginSucces() {
      const partner = this.loginStatu.partner;
      setTimeout(
        () =>
          this.$router.push(
            { path: `/courier/inbound?partner=${partner}` },
            onComplet => {},
            onAbort => {}
          ),
        2000
      );
    }
  }
};
</script>
<style lang="scss">
.courier-login {
  margin-top: rem(64);
  .qrcode {
    display: inline-block;
    padding: rem(30);
    position: relative;
    img {
      margin: 0 auto;
    }
    &.wechat {
      background: #f4f4f4;
    }
    .login-mask {
      background: rgba(255, 255, 255, 0.7);
      position: absolute;
      text-align: center;
      //line-height: 235px;
      padding-top: 80px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
  .text {
    font-size: rem(28);
    margin-top: rem(32);
    .van-icon {
      vertical-align: middle;
    }
  }
  &-left {
    text-align: center;
    border-right: 1px solid #a8afb3;
    padding-top: rem(30);
  }
  &-right {
    padding-top: rem(30);
    text-align: center;
  }
}
</style>
